module.exports = __webpack_public_path__ + "img/fashion-icon.9acef7c3c8a63dc75aa5d32f64c54888.svg";